<script setup lang="ts">
// import { defineProps } from 'vue'
import type { BlogArticle } from "~/types/blog";
import { formatDateByLocale } from "~/utils/math_utils"
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n()
const props = defineProps<{
	article: BlogArticle
}>()


const dateStr = computed(() => {
	return formatDateByLocale(locale.value, props.article.date)
})
// ✅ 定义四个分类，用于区分不同内容板块
const categories = [
	{ key: 'latest', label: t('editor_tutorial_consultation_menu_1'), value: '1' },
	{ key: 'release', label: t('editor_tutorial_consultation_menu_2'), value: '2' },
	{ key: 'tutorial', label: t('editor_tutorial_consultation_menu_3'), value: '3' },
	{ key: 'industry', label: t('editor_tutorial_consultation_menu_4'), value: '4' },
] as const;

const categoryLabelMap = categories.reduce<Record<string, string>>((acc, item) => {
	acc[item.value] = item.label;
	return acc;
}, {});

</script>

<template>
	<nuxt-link :to="article.toPath" style="text-decoration: none;">
		<el-card class="blog-card no-rem" shadow="never">
			<template #header>
				<!-- 图片 -->
				<CommonImage :src="article.image" lazy :alt="article.title || ''" fit="cover" imageClass="blog-card-img" />
			</template>
			<!-- 分类 -->
			<el-tag type="success" size="default">
				{{ categoryLabelMap[article.category] || article.category }}
			</el-tag>
			<!-- 标题 -->
			<h2 class="blog-card-title">{{ article.title }}</h2>
			<!-- 描述 -->
			<p class="blog-card-desc">{{ article.description }}</p>
			<template #footer>
				<!-- 作者 -->
				<div class="blog-card-footer">
					<span class="blog-card-footer-date">{{ dateStr }}</span>
					<nuxt-link :to="article.toPath" class="link_color">
						<div class="link_color_text">{{ t('editor_reading_all_text') }}</div>
						<!-- <i class="iconfont icon-icon_to"></i> -->
					</nuxt-link>
					<!-- <el-avatar :src="article.authors[0].avatarUrl" /> -->
				</div>
			</template>
		</el-card>
	</nuxt-link>
</template>

<style scoped lang="scss">
.blog-card.no-rem {
	min-height: 450px;
	border: 1px solid #DEDEDE;
	&:hover {
		box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
		cursor: pointer;
	}

	.blog-card-img {
		width: 100%;
		height: 220px;
		object-fit: cover;
	}

	.blog-card-title {
		font-size: 20px;
		font-weight: 600;
		margin-top: 10px;
		min-height: 50px;
	}

	.blog-card-desc {
		font-size: 14px;
		min-height: 40px;
		line-height: 24px;
		margin-top: 10px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.blog-card-footer {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		.blog-card-footer-date{
			font-size: 14px;
		}
		.link_color{
			font-size: 14px;
			.icon_to{
				margin-left: 5px;
			}
			.link_color_text {
				color:var(--primary-color);
				font-size: 14px;
				line-height: 20px;
				border-bottom: 1px solid transparent;
			}
			.link_color_text:hover {
				color: var(--hover-color);
				border-bottom: 1px solid var(--hover-color);
			}
		}
	}
}
</style>
<style lang="scss">

.blog-card {
	border-radius: 8px;

	.el-card__header {
		padding: 0;
		border-bottom: 0;
	}

	.el-card__footer {
		border-top: 0;
		padding-top: 0;
	}
}
</style>
